import { CHANGE_IMPORT_PAGE, CHANGE_IMPORT_REQUEST_PAGE } from '../actions/query';

export default function (state = {}, action) {
  switch (action.type) {
  case CHANGE_IMPORT_PAGE:
    return {
      ...state,
      importPage: action.page
    };
  case CHANGE_IMPORT_REQUEST_PAGE:
    return {
      ...state,
      importRequestPage: action.page
    };
  default:
    return state;
  }
}
